import { createFileRoute, notFound } from "@tanstack/react-router";
import { lazy } from "react";

// `import.meta.env.DEV` derleme anında sabitlenir: üretim paketinde vitrin kodu hiç yer almaz ve adres 404 verir.
const Showcase = import.meta.env.DEV
  ? lazy(async () => ({ default: (await import("../dev/ui-showcase.js")).UiShowcase }))
  : () => null;

export const Route = createFileRoute("/dev/ui-showcase")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound();
  },
  component: Showcase,
});
